module.exports = __webpack_public_path__ + "static/CircularStd-Black-94a505bb1e062b41273a8ea77777a3e7.woff2";